import Markdown from "react-markdown";
import { useIntl } from "react-intl";
import { useState } from "react";

import meeting1 from "../../../../../assets/icon/meeting-1.svg";
import table from "../../../../../assets/icon/mesa-1.svg";
import boardMeeting from "../../../../../assets/icon/board-meeting 1.svg";
import conference from "../../../../../assets/icon/conferencia-1.svg";

interface AccordionItem {
  id: string;
  title: string;
  icon: JSX.Element;
  content: string;
}

export const Faq = () => {
  const { formatMessage } = useIntl();
  const [expandedItem, setExpandedItem] = useState<string>("GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_1");

  const toggleItem = (id: string) => {
    setExpandedItem(expandedItem === id ? "" : id);
  };

  const faqItems: AccordionItem[] = [
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_1",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_1",
      }),
      icon: <img src={meeting1} alt="Meeting 1" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_2",
      }),
    },
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_3",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_3",
      }),
      icon: <img src={table} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_4",
      }),
    },
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_5",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_5",
      }),
      icon: <img src={boardMeeting} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_6",
      }),
    },
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_7",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_7",
      }),
      icon: <img src={conference} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_8",
      }),
    },
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_9",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_9",
      }),
      icon: <img src={conference} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_10",
      }),
    },
    {
      id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_11",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_11",
      }),
      icon: <img src={conference} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FAQ_CONTENT_12",
      }),
    },
  ];

  return (
    <section className="pt-16">
      <div className="container mx-auto max-w-4xl">
        <div className="flex justify-center">
          <div className="w-full">
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p
                    className="w-fit mx-auto mb-8 px-16 pt-6 text-2xl text-center border-t-1 border-t-black"
                    {...rest}
                  >
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({
                id: "GUIDE_FOR_EXPERT_MEETING_FAQ_TITLE",
              })}
            </Markdown>
            <div id="accordion">
              {faqItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-white mb-2 overflow-hidden transition-all duration-300 border-1 border-primary-light"
                >
                  <button
                    onClick={() => toggleItem(item.id)}
                    className="w-full flex items-center justify-between p-4 bg-primary-light text-white transition-colors z-10 relative"
                    aria-expanded={expandedItem === item.id}
                  >
                    <div className="flex items-center gap-4">
                      <Markdown
                        components={{
                          p: ({ children, ...rest }) => (
                            <p className="text-lg" {...rest}>
                              {children}
                            </p>
                          ),
                        }}
                      >
                        {item.title}
                      </Markdown>
                    </div>
                  </button>
                  <div
                    className={`transition-all duration-300 ease-in-out ${
                      expandedItem === item.id
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className={`bg-white p-4`}>
                      <Markdown>{item.content}</Markdown>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
